import React from 'react';
import { HexColorInput, HexAlphaColorPicker } from 'react-colorful';
import getFonts from '../../../Functions/config/fonts';
import getSelectField from '../../fields/select';
import toggleColorPicker from '../../../Functions/toggleColorPicker';

const Header = ({ widget, handleInputChange, setColorsAndPreview }) => {
    const { affordability } = widget.htmlData;
    const fontFamilyOptions = getFonts().map(font => ({ value: font, label: font }));

    return (
        <div className="mjwi-acc-panel-wrapper">
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>header color</label>
                </div>
                <div className="mjwi-col66 mjwi-clr-picker">
                    <span
                        className="clrPickerVal"
                        style={{ backgroundColor: affordability.header.textColor }}
                        onClick={toggleColorPicker}
                    ></span>
                    <HexAlphaColorPicker
                        color={affordability.header.textColor}
                        onChange={(color) => setColorsAndPreview('header', 'textColor', color)}
                        style={{ display: 'none' }}
                        className="mjwi-apfl-color-picker"
                    />
                    <HexColorInput
                        color={affordability.header.textColor}
                        onChange={(color) => setColorsAndPreview('header', 'textColor', color)}
                    />
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Font Family</label>
                </div>
                <div className="mjwi-col50">
                    {getSelectField('fontFamily', fontFamilyOptions.map(opt => opt.label), affordability.header.fontFamily, (e) => handleInputChange(e, ['header']))}
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Font Weight</label>
                </div>
                <div className="mjwi-col50">
                    {getSelectField('fontWeight', ['normal', 'bold', '100', '200', '300', '400', '500', '600', '700', '800', '900'], affordability.header.fontWeight, (e) => handleInputChange(e, ['header']))}
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Text Align</label>
                </div>
                <div className="mjwi-col50">
                    {getSelectField('textAlign', ['left', 'center', 'right'], affordability.header.textAlign, (e) => handleInputChange(e, ['header']))}
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50 mjwi-row">
                    <label htmlFor="headerFontSize">Font</label>
                </div> 
                <div className="mjwi-col33">
                <div className="mjwi-size-input">
                    <input
                            type="number"
                            name="fontSize"
                            value={parseFloat(affordability.header.fontSize) || ''}
                            onChange={(e) => handleInputChange({ target: { name: 'fontSize', value: `${e.target.value}px` } }, ['header'])}
                            className="mjwi-input"
                            min="0"
                    />
                </div>
                </div>
            </div>
        </div>
    );
};

export default Header;